import script from "./information-form-mgmt-edit.vue?vue&type=script&lang=tsx&setup=true"
export * from "./information-form-mgmt-edit.vue?vue&type=script&lang=tsx&setup=true"

import "./information-form-mgmt-edit.vue?vue&type=style&index=0&id=1846fb72&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1846fb72"]])

export default __exports__